import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "reactfire";
import useAdminAccess from "../hooks/use_admin_access";
import { AdminModule, canAccessModule, getDefaultAdminPath } from "../utils/admin_access";

interface PrivateRouteProps {
  element: JSX.Element;
  module?: AdminModule;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element, module }) => {
  const auth = useAuth();
  const { allowedModules, hasResolved } = useAdminAccess();

  if (!auth.currentUser) {
    return <Navigate to="/admin/login" replace />;
  }

  if (hasResolved && !canAccessModule(allowedModules, module)) {
    return <Navigate to={getDefaultAdminPath(allowedModules)} replace />;
  }

  return element;
};

export default PrivateRoute;
